// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export interface ISsoPendingSignup {
	email: string | undefined;

	firstName: string | undefined;

	lastName: string | undefined;

	orgNameSuggestion: string | undefined;

	$type?: string | undefined;
}
export class SsoPendingSignup {
	constructor(data?: ISsoPendingSignup) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
	}

	email: string | undefined;

	firstName: string | undefined;

	lastName: string | undefined;

	orgNameSuggestion: string | undefined;

	static $type: string = "CoreApi.Models.View.SsoPendingSignup, ";
	$type?: string | undefined = SsoPendingSignup.$type;
}

